import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getQuery } from "../ServiceController";

export default function useComunicazioniImportanti(carica = true) {
  const dispatch = useDispatch();
  const [messaggi, setMessaggi] = useState([]);

  useEffect(() => {
    if (!carica) return;
    let active = true;
    // L'API applica validità e regioni dei registri IVA della struttura.
    dispatch(getQuery("Comunicazioni/ElencoComunicazioniAttive"))
      .then(data => {
        if (active) setMessaggi((data || []).filter(m => m.importante));
      })
      .catch(error => console.error("Errore nel caricamento delle comunicazioni importanti", error));
    return () => { active = false; };
  }, [dispatch, carica]);

  return messaggi;
}
